module.exports = __webpack_public_path__ + "svg/employment.9603ab8.svg";